import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';



@Injectable()
export class ServiciosExternosEffects {

    constructor(
        private readonly actions$: Actions
    ) { }
}